import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { User } from '../../types';
import { AppDispatch } from '../store';
import { loginApi } from '../../services/auth-service';

export interface UserState {
  user: User | null;
  isAuthenticated: boolean;
  loading: boolean;
  error: string | null;
}

const initialState: UserState = {
  user: null,
  isAuthenticated: false,
  loading: false,
  error: null,
};

// Real implementation using the backend login API
export const login = (credentials: { username: string; password: string }) => {
  return async (dispatch: AppDispatch) => {
    try {
      dispatch(loginStart());

      // Call the real login API
      const userData = await loginApi(credentials.username, credentials.password);

      console.log('User login succeeded with role:', userData.role);

      dispatch(loginSuccess(userData));
    } catch (error) {
      let errorMessage =
        'Ops! Não foi possível acessar sua conta. Verifique seu e-mail e senha e tente novamente.';

      if (error instanceof Error) {
        errorMessage = error.message;
      }

      dispatch(loginFailure(errorMessage));
    }
  };
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    loginStart: state => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action: PayloadAction<User>) => {
      state.loading = false;

      // Validate that user has a valid role
      const userData = action.payload;
      console.log('Setting user with validated role:', userData.role);

      state.user = userData;
      state.isAuthenticated = true;

      // Store user data in localStorage for persistence and access during redirects
      localStorage.setItem('user', JSON.stringify(userData));
    },
    loginFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    logout: state => {
      state.user = null;
      state.isAuthenticated = false;
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('rememberMe');
    },
    setUser: (state, action: PayloadAction<User>) => {
      // Ensure role is valid before setting
      const userData = action.payload;
      console.log('setUser action with role:', userData.role);

      state.user = userData;
      state.isAuthenticated = true;

      // Store user data in localStorage for persistence
      localStorage.setItem('user', JSON.stringify(userData));
    },
    clearError: state => {
      state.error = null;
    },
  },
});

export const { loginStart, loginSuccess, loginFailure, logout, setUser, clearError } =
  userSlice.actions;
export default userSlice.reducer;
